import React, { useState } from 'react';

import Show from 'components/Show';
import Browser from 'components/Browser';
import { Input, Button } from 'components/Misc/Form';

const Thumbnail = ({ label, name, value, path, folder, onChange }) => {
	// Store browser's visibility
	const [browser, setBrowser] = useState(false);

	// Handle thumbnail selection
	const onSelect = thumbnail => {
		onChange({
			name,
			value: thumbnail
		});

		// Close browser on selection
		setBrowser(false);
	};

	// Handle thumbnail clear
	const onClear = () => {
		onChange({
			name,
			value: ''
		});
	};

	// Handle browser's toggle
	const onBrowser = () => setBrowser(prev => !prev);

	return (
		<div className="flex items-end space-x-2">
			<Input
				readOnly
				label={label}
				value={value}
				className="flex-1"
			/>

			<Show if={value}>
				<Button
					icon="close"
					value="Noņemt"
					theme="danger"
					onClick={onClear}
				/>
			</Show>

			<Button
				icon="image"
				theme="informative"
				value="Izvēlēties"
				onClick={onBrowser}
			/>

			<Browser
				path={path}
				folder={folder}
				visible={browser}
				onClose={onBrowser}
				onSelect={onSelect}
			/>
		</div>
	);
};

export default Thumbnail;